<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-import-alt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 18v4H8v20h32V22h-4v-4h6a2 2 0 012 2v24a2 2 0 01-2 2H6a2 2 0 01-2-2V20a2 2 0 012-2h6zm21 16a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18zm0-8a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h18zM23.009 2.358l1.894.006a1 1 0 01.99.878l.007.116.071 12.218 4.242-4.242a1 1 0 011.32-.083l.094.083 1.415 1.414a1 1 0 01.083 1.32l-.083.095-7.779 7.778a2 2 0 01-2.7.117l-.128-.117-7.778-7.778a1 1 0 01-.083-1.32l.083-.095 1.414-1.414a1 1 0 011.32-.083l.094.083 4.593 4.595-.072-12.565a1.002 1.002 0 011.003-1.006z"/></svg>
</template>
<script>

export default {
  name: 'IconImportAlt',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
